import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Tache } from '../../../models/taches/gestion-taches.model';

@Component({
  selector: 'app-liste-taches',
  templateUrl: './liste-taches.component.html',
  styleUrls: ['./liste-taches.component.scss']
})
export class ListeTachesComponent implements OnInit {

  @Output() fermer = new EventEmitter();
  @Output() itemAModifier: EventEmitter<Tache> = new EventEmitter<Tache>();
  @Output() rechargerList: EventEmitter<Tache> = new EventEmitter();
  @Output() itemSupprime: EventEmitter<number> = new EventEmitter<number>();
  @Input() tachesChange: Observable<Tache[]> = new Observable<Tache[]>();

  @Input() isAjoutEnabled: boolean;
  @Input() isModifierEnabled: boolean;
  @Input() isSupprimerEnabled: boolean;
  @Input() isNaviguerEnabled: boolean;

  public listeTaches: Tache[] = [];

  constructor() {}

  ngOnInit(): void {
    this.tachesChange.subscribe(taches => {
      this.listeTaches = taches ?? [];
    });
  }

  get isTachesVisible(): boolean {
    return this.listeTaches?.length > 0;
  }

  creerTache() {
    this.itemAModifier.next(new Tache());
  }

  editerTache(tache: Tache) {
    this.itemAModifier.next(tache);
  }

  close() {
    this.fermer.emit();
  }

  public loadTaches(tache: Tache) {
    this.rechargerList.emit(tache);
  }
}
